import { useQuery } from '@tanstack/react-query';
import { taskerApi } from '@/api/tasker';

/**
 * Fetch Tasker tasks for current user.
 * Enabled only when VITE_TASKER_API_URL is configured.
 * Silent fail — returns empty array on error.
 */
export function useTaskerTasks() {
  return useQuery({
    queryKey: ['tasker-tasks'],
    queryFn: () => taskerApi.listMyTasks(),
    enabled: !!import.meta.env.VITE_TASKER_API_URL,
    retry: 1,
    refetchOnWindowFocus: true,
    staleTime: 60_000,
  });
}
